import { uuidv4 } from "../../utility";

export const ConfirmationService = {
  confirmationList: [],
  confirmationListHandlers: [],
  onConfirmationChanged: function(handler) {
    this.confirmationListHandlers = [...this.confirmationListHandlers, handler];
  },
  confirmationChanged: function() {
    this.confirmationListHandlers.forEach(handler => {
      handler(this.confirmationList);
    });
  },
  create: function({
    subject = "Are you sure you want to continue ?",
    body = "",
    model = true,
    width = 376,
    results = [
      createConfirmResult({
        value: "Cancel"
      }),
      createConfirmResult({
        value: "OK",
        classes: ["v1"]
      })
    ],
    completed = message => console.log(message),
    cancelDelay = 100
  }) {
    const id = uuidv4();

    const confirmation = {
      id,
      subject,
      body,
      model,
      width,
      results,
      complete: message => {
        const result = results.find(e => e.name === message);
        completed(message);
        setTimeout(() => {
          this.confirmationList = this.confirmationList.filter(
            c => c.id !== id
          );
          this.confirmationChanged();
        }, cancelDelay);
      }
    };

    this.confirmationList.push(confirmation);
    this.confirmationChanged();

    return confirmation;
  },
  createP: function({
    subject = "",
    body = "",
    model = true,
    /** Width of the Confirmation Window */
    width = 376,
    /** Results are the possible button Arrays */
    results = [
      createConfirmResult({
        value: "Cancel",
        classes: ["ut-mt-0 ut-mb-0"]
      }),
      createConfirmResult({
        value: "OK",
        classes: ["v1 ut-mt-0 ut-mb-0"]
      })
    ],
    /** The Delay time the Confirmation Window will close after user confirms a result */
    cancelDelay = 100,
    optionsJustify = 'flex-end',
    subjectClass = ''
  }) {
    return new Promise((resolve, reject) => {
      const id = uuidv4();

      const confirmation = {
        id,
        subject,
        subjectClass,
        body,
        model,
        width,
        results,
        optionsJustify,
        complete: message => {
          console.log({'confirmation.service.js:90 message' : message});
          const result = results.find(e => e.value === message) || results.find(e => e.name === message);
          console.log({'confirmation.service.js:92 result' : result});
          console.log({'confirmation.service.js:92 results' : results});

          /** Resolving the result of the Confirmation Window */
          resolve(message);
          setTimeout(() => {
            this.confirmationList = this.confirmationList.filter(
              c => c.id !== id
            );
            this.confirmationChanged();
          }, cancelDelay);
        }
      };

      this.confirmationList.push(confirmation);
      this.confirmationChanged();
    });
  }
};

export const createConfirmResult = ({ text, value, classes }) => {
  if (text && !value) {
    value = text;
  }
  if (!text && value) {
    text = value;
  }
  if (!text && !value) {
    throw Error("Specify At least a Value or Text");
  }

  return {
    text,
    value,
    classes
  };
};
